export const ungatedCategoryMetaDescriptions = [
  {
    path: '/categories/alcohol/beer/non-alcoholic',
    description:
      'Enjoy the convenience of same-day delivery on your favorite Non-Alcoholic Beers when you order via Shipt. Get your favorite products delivered instantly!',
  },
  {
    path: '/categories/alcohol/spirits',
    description:
      'Browse a wide selection of premium Spirits and have them delivered the same day via Shipt. Find your favorite brands and discover new ones today!',
  },
  {
    path: '/categories/alcohol/spirits/vodka',
    description:
      'Our premium Vodka selection is perfect for cocktails and sipping, and can be delivered the same day via Shipt. Find the perfect bottle for any occasion today!',
  },
  {
    path: '/categories/alcohol/wine/specialty-and-flavored',
    description:
      'You can find something sweet or savory in our Specialty and Flavored Wine selection and have it delivered the same day. Find your new favorite today!',
  },
  {
    path: '/categories/alcohol/hard-seltzer-and-more/cider',
    description:
      'Whether you prefer a crisp, dry cider or a fruity, sweet one, find your favorite Hard Cider or try a new one. Order now & have Hard Cider delivered the same day!',
  },
  {
    path: '/categories/alcohol/spirits/rum',
    description:
      'From light & spiced to dark & aged, shop our wide collection of Rum and have it delivered the same day via Shipt. Shop online now!',
  },
  {
    path: '/categories/alcohol/spirits/cordials-and-liqueurs',
    description:
      'Enhance your cocktails with our diverse selection of Cordials and Liqueurs. Shop online and enjoy same-day delivery via Shipt!',
  },
  {
    path: '/categories/alcohol/beer/craft',
    description:
      'Discover our wide selection of IPAs, stouts, sours, and more, and have your favorite Craft Beer delivered the same day via Shipt. Order online now!',
  },
  {
    path: '/categories/alcohol/hard-seltzer-and-more/hard-soda-and-seltzer',
    description:
      'Order variety packs, unique flavors, and all your favorite Hard Seltzer brands and have them delivered the same day via Shipt. Shop online now!',
  },
  {
    path: '/categories/alcohol/hard-seltzer-and-more/malt-beverages',
    description:
      'Choose from a variety of refreshing Malt Beverages that are perfect for parties, BBQs, and more. Get them delivered to your door on the same day!',
  },
  {
    path: '/categories/alcohol/wine',
    description:
      'Choose from our selection of Red, White, Rosé Wines, & more, & let us transport your taste buds. Shop online now & get Wine delivered today via Shipt.',
  },
  {
    path: '/categories/alcohol/spirits/tequila',
    description:
      'From blanco to añejo, find your favorite Tequila brands and explore new distilleries. Shop online now and get Tequila delivered same day!',
  },
  {
    path: '/categories/alcohol/wine/white',
    description:
      'From Sauvignon Blanc to Chardonnay, find the perfect White Wine for any occasion. Shop now & get your order delivered to your door in as soon as an hour via Shipt.',
  },
  {
    path: '/categories/alcohol/spirits/whiskey',
    description:
      'From smoky Scotch to bold Bourbon, explore our extensive selection of Whisky and enjoy same-day delivery for your online orders via Shipt.',
  },
  {
    path: '/categories/alcohol/wine/rose-and-blushes',
    description:
      'Shop our range of light, fruity, and refreshing Rosé & Blush Wines and find your perfect shade. Enjoy same-day delivery when you order now via Shipt.',
  },
  {
    path: '/categories/alcohol/wine/red',
    description:
      'Explore our selection of Red Wines, from Zinfandel to Pinot Noir, and discover your new favorite. Shop online today for same-day delivery via Shipt.',
  },
  {
    path: '/categories/alcohol/hard-seltzer-and-more/prepared-cocktails',
    description:
      'Explore our range of Prepared Cocktails and enjoy them without the hassle of mixing. Order online today for same-day delivery in as little as one hour via Shipt.',
  },
  {
    path: '/categories/alcohol/beer',
    description:
      'Explore our range of Craft, Domestic, Imported, and Non-Alcoholic Beers to find your perfect brew. Order online now for same-day delivery via Shipt.',
  },
  {
    path: '/categories/alcohol/hard-seltzer-and-more',
    description:
      'Discover our variety of Hard Seltzers and Prepared Cocktails, perfect for parties, picnics, and more. Order online now for same-day delivery via Shipt.',
  },
  {
    path: '/categories/alcohol/wine/champagne-and-sparkling',
    description:
      'Choose the perfect Champagne & Sparkling Wine for appetizers, desserts, celebrations, & more, and have them delivered the same day via Shipt. Shop online now!',
  },
  {
    path: '/categories/alcohol/beer/domestic',
    description:
      "America's finest beers, delivered right to your door! Browse our selection of Domestic Beers & enjoy fast delivery via Shipt.",
  },
  {
    path: '/categories/alcohol',
    description:
      'Your one-stop shop for all things alcohol. Wine, Beer, Hard Seltzers, Spirits, and more, delivered to your door via Shipt.',
  },
  {
    path: '/categories/alcohol/beer/imported',
    description:
      'Browse our collection of Imported Beers from Germany, Japan, Mexico, and more. Discover unique international flavors and enjoy same-day delivery through Shipt.',
  },
  {
    path: '/categories/deli',
    description:
      'Browse our selection of deli meats, dips, & cheeses for sandwiches, snacks, & parties. Get your Deli products delivered the same day via Shipt today!',
  },
  {
    path: '/categories/breads-and-bakery',
    description:
      'Shop our bakery online and find your favorite bread, pastries, cakes, and more. Enjoy freshly baked goodness delivered right to your door via Shipt.',
  },
  {
    path: '/categories/beauty',
    description:
      'Our wide selection of makeup, skincare, haircare, & more will help you look & feel your best. Shop now & get your Beauty products delivered the same day via Shipt.',
  },
  {
    path: '/categories/household-essentials',
    description:
      'Stock up on household essentials without leaving home. Order all your household essentials in one place and get them delivered the same day via Shipt.',
  },
  {
    path: '/categories/pets',
    description:
      'Explore our selection of pet products, including food, toys, grooming supplies, & more. Shop online now & get your Pet products delivered the same day via Shipt.',
  },
  {
    path: '/categories/baby-and-toddler',
    description:
      'From diapers to formula, we have everything you need. Shop online today for all your Baby & Toddler essentials & get them delivered the same day through Shipt.',
  },
  {
    path: '/categories/international',
    description:
      'Find ingredients for your next international dinner. Browse our selection of salsa, sriracha, noodles, & more, & get them delivered the same day via Shipt.',
  },
  {
    path: '/categories/kitchen-and-dining',
    description:
      'Looking to upgrade your cookware or find the perfect serving dish? Shop our kitchen and dining essentials, and enjoy same-day delivery via Shipt.',
  },
  {
    path: '/categories/patio-and-garden',
    description:
      'Shop garden tools, grilling essentials, & more. Discover everything you need for your outdoor space & enjoy same-day delivery of your favorite products via Shipt.',
  },
  {
    path: '/categories/entertainment',
    description:
      'Find the perfect entertainment for any occasion. Shop books, movies, & more. Enjoy same-day delivery on all products when you order now!',
  },
  {
    path: '/categories/electronics',
    description:
      'Find all the electronics you need in one place. Shop smartphones, batteries, headphones, and more. Shop online today and enjoy same-day delivery with Shipt.',
  },
  {
    path: '/categories/toys',
    description:
      'Shop dolls, action figures, board games, card games, & more. Find the perfect toy and games for kids of all ages. Shop now & enjoy same-day delivery with Shipt.',
  },
  {
    path: '/categories/mens-and-womens-apparel',
    description:
      "Find everything you need for your wardrobe, from socks to shirts. Shop our range of men's & women's apparel & get your products delivered the same day via Shipt.",
  },
  {
    path: '/categories/kids-apparel',
    description:
      'Find the perfect outfit for every occasion. Shop our selection of kids apparel and accessories, available for same-day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy',
    description:
      "From classic sweets to gourmet snacks, we've got the perfect treat for every craving. Shop now & get your favorite Snacks & Candy products delivered with Shipt.",
  },
  {
    path: '/categories/snacks-and-candy/chips',
    description:
      'Shop potato chips, tortilla chips, veggie chips, & more. Order your favorite Chips today and get same-day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/crackers',
    description:
      'Shop cheese crackers, wheat crackers, multigrain crackers, and more. Shop our selection of Crackers today and enjoy same day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/candy-and-chocolate',
    description:
      'Craving something sweet? Shop our selection of chocolate & candy, from rich, decadent bites to fruity, chewy treats and get same-day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/cookies-and-snack-cakes',
    description:
      'Shop our cookies and snack cakes for parties, gatherings, or just because. Order your favorites today and get same day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/fruit-and-vegetable-snacks',
    description:
      'Discover fruit and vegetable snacks perfect for healthy, on-the-go munching. Order your fruit and vegetable snacks now and enjoy same-day delivery with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/granola-and-nutrition-bars',
    description:
      'Shop granola bars, protein bars, breakfast bars, & more. Find your perfect energy boost and get your Granola & Nutrition Bar products delivered with Shipt.',
  },
  {
    path: '/categories/snacks-and-candy/nuts-and-seeds',
    description:
      'Shop for almonds, cashews, pistachios, sunflower seeds, & more. Discover your ideal healthy nut and seed snacks and have them delivered the same day with Shipt.',
  },
  {
    path: '/categories/beauty/hair-care/hair-loss-and-growth-products',
    description: `Support healthy hair growth with trusted products from your local stores, right to your doorstep. Delivered same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/beauty/hair-care/heat-hair-styling-tools',
    description: `Style your hair with ease using heat tools from your local stores, right to your doorstep. Shop now for same-day delivery—often as soon as an hour—with Shipt.`,
  },
  {
    path: '/categories/beauty/hair-care/hair-styling-products',
    description: `Style your hair with gels, sprays, and more from your local stores, straight to your doorstep. Same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/beauty/makeup/eyes-and-brows-makeup',
    description: `Define your look with eye & brow makeup from your local stores, right to your doorstep. Shop top brands with same-day delivery in as soon as an hour via Shipt.`,
  },
  {
    path: '/categories/beauty/makeup/lip-makeup',
    description: `Pucker up with lipsticks, glosses, and more from your local stores, straight to your doorstep. Same-day delivery in as little as an hour via Shipt.`,
  },
  {
    path: '/categories/beauty/skin-care/sun-care-and-tanning-products',
    description: `Protect your skin with sun care essentials from your local stores, right to your doorstep. Get same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/beverages/soft-drinks/grape-soda',
    description: `Quench your thirst with grape soft drinks from your local stores, right to your doorstep. Refreshing options, same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/beverages/sparkling-water/unflavored-sparkling-water',
    description: `Refresh with crisp, unflavored sparkling water from your local stores, straight to your doorstep. Order now for same-day delivery in as little as an hour.`,
  },
  {
    path: '/categories/dairy/butter-and-margarine/butter-sticks',
    description: `Perfect your recipes with butter sticks from your local stores, right to your doorstep. Same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/dairy/refrigerated-doughs/cookie-dough',
    description: `Bake fresh cookies anytime with refrigerated dough from your local stores, straight to your doorstep. Get it same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/frozen-foods',
    description: `From meals to sides, shop frozen favorites from your local stores, right to your doorstep. Get them same day, often in as soon as an hour, with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/apps-and-sides/frozen-vegetable-apps-and-sides',
    description: `Serve up tasty veggie apps and sides in minutes. Get them with same-day delivery from your local storesin as little as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-breakfast',
    description: `Start your day with frozen breakfast favorites from your local stores, straight to your doorstep. Delivered same day, often in as soon as an hour, via Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-artichokes-and-asparagus',
    description: `Stock up on frozen artichokes and asparagus from your local stores, straight to your doorstep. Get same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-beans-peas-and-okra',
    description: `Enjoy frozen beans, peas, and okra from your local stores, straight to your doorstep. Same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-broccoli-and-cauliflower',
    description: `Frozen broccoli and cauliflower from your local stores, straight to your doorstep. Delivered same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-carrots-and-root-vegetables',
    description: `Add color with frozen carrots and root veggies from your local stores, straight to your doorstep. Same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-corn',
    description: `Stock up on frozen corn, ready for any recipe. Same-day delivery from your local stores to your doorstep in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/frozen-vegetables/frozen-peppers',
    description: `Add color and flavor with frozen peppers from your local stores, straight to your doorstep. Same-day delivery available in as little as an hour via Shipt.`,
  },
  {
    path: '/categories/frozen-foods/ice-cream-and-dessert/frozen-cookie-dough',
    description: `Indulge in frozen cookie desserts anytime. Enjoy same-day delivery from your local stores in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/pizza-and-pizza-snacks/frozen-cheese-pizza',
    description: `Craving cheese pizza? Get frozen favorites same day—in as little as an hour—from your local stores to your doorstep with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/pizza-and-pizza-snacks/frozen-combination-pizza',
    description: `Get the best of both worlds with combo pizzas from your local stores. Order now for same-day delivery in as soon as an hour from Shipt.`,
  },
  {
    path: '/categories/frozen-foods/pizza-and-pizza-snacks/frozen-meat-pizza',
    description: `Satisfy cravings with meat-loaded frozen pizzas, store to doorstep. Order now for same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/frozen-foods/pizza-and-pizza-snacks/frozen-vegetable-pizza',
    description: `Order frozen veggie pizzas made easy from your local stores, straight to your doorstep. Enjoy same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/gift-and-party/party-supplies/anniversary-party-supplies',
    description: `Celebrate love in style with anniversary party supplies from your local stores, right to your doorstep. Same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/gift-and-party/party-supplies/party-decor',
    description: `Set the scene with stylish party decor from your local stores, straight to your doorstep. Delivered same day—in as soon as an hour—with Shipt.`,
  },
  {
    path: '/categories/gift-and-party/party-supplies/graduation-party-supplies',
    description: `Celebrate grads with party supplies from your local stores, straight to your doorstep. Shop now for same-day delivery in as little as an hour on Shipt.`,
  },
  {
    path: '/categories/meat-and-seafood/beef/beef-ribs',
    description: `Enjoy tender beef ribs for your next meal from your local stores, straight to your doorstep. Delivered fresh the same day, often in as soon as an hour, with Shipt.`,
  },
  {
    path: '/categories/meat-and-seafood/lunch-meat/beef-lunch-meat',
    description: `Make meals better with savory beef lunch meats from your local stores, straight to your doorstep. Delivered same day in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/meat-and-seafood/lunch-meat/chicken-lunch-meat',
    description: `Sandwich-ready chicken lunch meat from your local stores, straight to your doorstep. Get it same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/meat-and-seafood/lunch-meat/turkey-lunch-meat',
    description: `Keep it lean with turkey lunch meat from your local stores, straight to your doorstep. Same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/meat-and-seafood/pork/pork-ribs',
    description: `Grill-ready pork ribs delivered fast and fresh from your local stores. Shop now for same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/pantry/condiments-and-dressings/bbq-sauce',
    description: `Fire up the flavor with top BBQ sauces from your local stores to your doorstep in as little as an hour with same-day delivery from Shipt.`,
  },
  {
    path: '/categories/pantry/condiments-and-dressings/caesar-dressing',
    description: `Add bold flavor with Caesar dressings from your local stores, right to your doorstep. Get them delivered same day, often in as soon as an hour, with Shipt.`,
  },
  {
    path: '/categories/personal-care/deodorants-and-antiperspirant/mens-deodorant-and-antiperspirant',
    description: `Stay fresh with men’s deodorants and antiperspirants. Shop top brands with same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/personal-care/diet-and-nutrition/meal-replacement-and-weight-loss-aids',
    description: `Support your goals with weight loss products from your local stores, right to your doorstep. Same-day delivery available in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/allergy-and-asthma-medicine',
    description: `Breathe easier with allergy & asthma relief products.Trusted brands from your local stores delivered same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/cough-cold-and-flu-medicine',
    description: `Stay prepared with cold and flu relief from your local stores, straight to your doorstep. Trusted brands delivered same day—in as little as an hour—with Shipt.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/digestion-and-nausea-medicine',
    description: `Soothe your stomach with digestion and nausea relief from your local stores, right to your doorstep. Shop now for same-day delivery in as little as an hour.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/jock-itch-treatment-products',
    description: `Get fast relief with jock itch treatments from your local stores, right to your doorstep. Order discreetly for same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/head-lice-treatment',
    description: `Tackle lice fast with effective treatments from your local stores, straight to your doorstep. Order now for same-day delivery in as little as an hour.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/pain-and-fever-medicine',
    description: `Ease pain and fever fast with trusted treatments from your local stores, right to your doorstep. Get same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/personal-care/medicines-and-treatments/sleeping-and-snoring-aids',
    description: `Sleep soundly with snoring and sleep aids from your local stores, right to your doorstep. Delivered same day, often in as soon as an hour, via Shipt.`,
  },
  {
    path: '/categories/produce/salad-mixes/leafy-salad-greens',
    description: `From your local stores straight to your doorstep: fresh, crisp leafy greens for quick meals. Shop now for same-day delivery in as little as an hour with Shipt.`,
  },
  {
    path: '/categories/produce/fresh-vegetables',
    description: `Fresh vegetables delivered straight to your kitchen from your local stores. Enjoy same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/snacks-and-candy/chips/chips-variety-and-multi-packs',
    description: `Snack smarter with chip variety packs from your local stores, straight to your doorstep. Same-day delivery available in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/snacks-and-candy/cookies-and-snack-cakes/cookies-variety-and-multi-packs',
    description: `Treat yourself to cookie and snack cake packs from your local stores, straight to your doorstep. Enjoy same-day delivery in as soon as an hour with Shipt.`,
  },
  {
    path: '/categories/snacks-and-candy/crackers/crackers-variety-and-multi-packs',
    description: `Crunch into cracker variety packs for any snack moment. Delivered same day, often in as soon as an hour, via Shipt.`,
  },
  {
    path: '/categories/sports-and-outdoor/exercise-and-fitness/free-weights',
    description: `Build strength at home with free weights such as dumbbells and kettlebells. Shop today for same-day delivery in as soon as an hour with Shipt.`,
  },
]
